// extracted by mini-css-extract-plugin
export default {"image":"DogImage_image__4i2QA"};